import { z } from 'zod';
import { INVITE_BATCH_MAX } from '../access.js';
/** What an administrator can do to somebody from the Users screen. Each is one route. */
export const USER_CHANGES = ['promote', 'demote', 'disable', 'enable', 'signout'];
export const InviteUsersRequestSchema = z.object({
    emails: z.array(z.string().trim().min(3).max(320)).min(1).max(INVITE_BATCH_MAX),
    /**
     * Email each newly invited address the sign-in link.
     *
     * Absent means no, so a client that predates the email sends nothing
     * nobody asked for.
     */
    sendEmail: z.boolean().optional(),
});
//# sourceMappingURL=users.js.map